import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const {
    isAuthenticated,
    loading,
    pendingConsents,
    consentChecked,
    refreshPendingConsents,
  } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && !consentChecked) {
      refreshPendingConsents();
    }
  }, [isAuthenticated, consentChecked, refreshPendingConsents]);

  if (loading || (isAuthenticated && !consentChecked)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
        data-testid="loading-spinner"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    const returnPath = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(returnPath)}`}
        replace
      />
    );
  }

  if (pendingConsents.length > 0 && !location.pathname.startsWith('/consent')) {
    const returnPath = `${location.pathname}${location.search}`;
    sessionStorage.setItem('consentRedirectTo', returnPath);
    return <Navigate to="/consent" replace />;
  }

  return children;
};

export default ProtectedRoute;
